import { render } from "./PostInfoComponent.vue?vue&type=template&id=4c3297b2&scoped=true&ts=true"
import script from "./PostInfoComponent.vue?vue&type=script&lang=ts"
export * from "./PostInfoComponent.vue?vue&type=script&lang=ts"

import "./PostInfoComponent.vue?vue&type=style&index=0&id=4c3297b2&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c3297b2"]])

export default __exports__